import Vue from 'vue'

// Lib imports
import axios from 'axios'

const PRIMARY_API_DOMAIN = 'https://wercbergerproductions-app-164903695581.us-east1.run.app'
const FALLBACK_API_DOMAIN = 'https://wercberger-productions.azurewebsites.net'

function normalizeDomain (domain) {
  return domain.endsWith('/') ? domain.slice(0, -1) : domain
}

function shouldRetryWithFallback (error) {
  const response = error && error.response
  const status = response && response.status
  const hasNoResponse = !response

  // Retry on temporary availability failures and network errors.
  return hasNoResponse || (status >= 500 && status <= 599)
}

function getFallbackUrl (url) {
  if (!url) {
    return null
  }

  const primary = normalizeDomain(PRIMARY_API_DOMAIN)
  const fallback = normalizeDomain(FALLBACK_API_DOMAIN)

  if (!url.startsWith(primary)) {
    return null
  }

  return url.replace(primary, fallback)
}

axios.interceptors.response.use(
  response => response,
  async error => {
    const config = error && error.config

    if (!config || config.__domainFallbackRetried) {
      return Promise.reject(error)
    }

    if (!shouldRetryWithFallback(error)) {
      return Promise.reject(error)
    }

    const fallbackUrl = getFallbackUrl(config.url)

    if (!fallbackUrl) {
      return Promise.reject(error)
    }

    config.__domainFallbackRetried = true
    config.url = fallbackUrl

    return axios(config)
  }
)

Vue.prototype.$http = axios
